import * as Sentry from '@sentry/vue';

let instance = null;

class FakeSentry {
  captureException(_) {} // eslint-disable-line
  init(_) {} // eslint-disable-line
  attach(_) {} // eslint-disable-line
}

export default class PhoenixSentry {
  config;
  captureException;

  constructor(config = {}) {
    this.config = config;

    if (this.config.env === 'locals') {
      instance = new FakeSentry();
      return instance;
    }

    if (this.config.user !== null) {
      const { id, email } = this.config.user;
      Sentry.setUser({ id, email });
    }

    this.captureException = Sentry.captureException;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    instance = this;
    return instance;
  }

  static getInstance() {
    return instance;
  }

  getSentryConfig() {
    return {
      release: this.config.release,
      dsn: this.config.sentryUrl,
      environment: `${this.config.env.toLowerCase()}-${this.config.dataCenter}`,
      denyUrls: this.config.urlsToIgnore,
      beforeSend(event, hint) {
        const error = hint.originalException;

        const errorStatusesToIgnore = [400, 401, 422];
        if (
          errorStatusesToIgnore.includes(error?.request?.status) ||
          errorStatusesToIgnore.includes(error?.response?.status)
        ) {
          return null;
        }

        const message = error?.message;
        if (!message || !(typeof message === 'string' || message instanceof String)) {
          return null;
        }

        for (const message of this.config.messagesToIgnore) {
          const re = new RegExp(message, 'g');
          if (re.exec(message)) {
            return null;
          }
        }

        return event;
      },
    };
  }

  init(app) {
    Sentry.init({ ...this.getSentryConfig(), app });
  }

  attach(app) {
    app.mixin(Sentry.createTracingMixins({ trackComponents: true }));
    Sentry.attachErrorHandler(app, this.getSentryConfig());
  }
}

export const sentry = PhoenixSentry.getInstance();
